import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import IdentifyPage from './pages/IdentifyPage'
import ResultsPage from './pages/ResultsPage'
import HistoryPage from './pages/HistoryPage'
import ProfilePage from './pages/ProfilePage'
import AdminPage from './pages/AdminPage'
import AdminConfigPage from './pages/AdminConfigPage'
import MarkDatabasePage from './pages/MarkDatabasePage'
import UserManagementPage from './pages/UserManagementPage'
import RegressionToolPage from './pages/RegressionToolPage'
import './App.css'
import GlobalErrorBoundary from './components/GlobalErrorBoundary'


// Protected Route Component
function ProtectedRoute({ children, requiredRole = null }) {
    const { user, userProfile, loading } = useAuth()

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="loading-spinner" />
                <p>Loading...</p>
            </div>
        )
    }

    if (!user) {
        return <Navigate to="/login" replace />
    }

    // If role is required but profile not yet loaded, wait (or handle as error)
    // For simplicity, if we have a user but no profile yet, we might want to wait or let them pass if no role required.
    // If role IS required, we MUST wait for profile.
    if (requiredRole && !userProfile) {
        return (
            <div className="loading-screen">
                <div className="loading-spinner" />
                <p>Checking permissions...</p>
            </div>
        )
    }

    if (requiredRole && userProfile?.role !== requiredRole) {
        return <Navigate to="/identify" replace />
    }

    return children
}

function App() {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Protected Routes */}
            <Route path="/" element={
                <ProtectedRoute>
                    <Layout />
                </ProtectedRoute>
            }>
                <Route index element={<Navigate to="/identify" replace />} />
                <Route path="identify" element={<IdentifyPage />} />
                <Route path="results/:id" element={<ResultsPage />} />
                <Route path="history" element={<HistoryPage />} />
                <Route path="profile" element={<ProfilePage />} />

                {/* Admin Routes - Role Protected */}
                <Route path="admin" element={
                    <ProtectedRoute requiredRole="admin">
                        <AdminPage />
                    </ProtectedRoute>
                } />
                <Route path="admin/config" element={
                    <ProtectedRoute requiredRole="admin">
                        <AdminConfigPage />
                    </ProtectedRoute>
                } />
                <Route path="admin/marks" element={
                    <ProtectedRoute requiredRole="admin">
                        <MarkDatabasePage />
                    </ProtectedRoute>
                } />
                <Route path="admin/users" element={
                    <ProtectedRoute requiredRole="admin">
                        <UserManagementPage />
                    </ProtectedRoute>
                } />
                <Route path="admin/regression" element={
                    <ProtectedRoute requiredRole="admin">
                        <RegressionToolPage />
                    </ProtectedRoute>
                } />

                <Route path="catalog" element={<MarkDatabasePage />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}

export default App
